import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { Box } from '../Box';

type BoxContainerVariants = 'static' | 'flexible';

export type BoxContainerProps = {
  children: ReactNode;
  variant?: BoxContainerVariants;
};

const StyledBoxContainer = styled(Box)<{ variant: BoxContainerVariants }>(
  ({ variant, theme }) => ({
    width: variant === 'static' ? 554 : '100%',
    boxSizing: 'border-box',
    padding: variant === 'static' ? 32 : 20,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    flexWrap: 'nowrap',
    background: 'var(--color-white)',
    border: '1px solid var(--color-general-grey-300)',
    borderRadius: '8px',

    '@media (max-width: 500px)': {
      width: '100%',
      padding: '24px 16px',
      gap: '16px',
      border: 'none',
    },
  })
);

export const BoxContainer = ({
  children,
  variant = 'static',
}: BoxContainerProps) => {
  return <StyledBoxContainer variant={variant}>{children}</StyledBoxContainer>;
};
